import { call, put, takeEvery, getContext } from "redux-saga/effects";

import { CONTEXT } from "@const/redux";
import {
  getMyPromotersFailure,
  getMyPromotersPortionFailure,
  getMyPromotersPortionSuccess,
  getMyPromotersSuccess,
  getPromotersByIdFailure,
  getPromotersByIdPortionFailure,
  getPromotersByIdPortionSuccess,
  getPromotersByIdSuccess,
} from "./actions";
import {
  getMyPromotersActionTypes,
  getMyPromotersPortionActionTypes,
  getPromotersByIdActionTypes,
  getPromotersByIdPortionActionTypes,
} from "./actionTypes";

const getMyPromotersAsync = ({ UsersService, params }) => {
  if (!UsersService) {
    console.log("Required services does not exist");
    return null;
  }

  return UsersService.getMyPromoters(params);
};

function* getMyPromoters({ payload: params }) {
  try {
    const { UsersService } = yield getContext(CONTEXT.SERVICES);

    const { data, pagination } = yield call(getMyPromotersAsync, {
      UsersService,
      params,
    });

    yield put(getMyPromotersSuccess({ data, ...pagination }));
  } catch ({ error }) {
    yield put(getMyPromotersFailure(error));
  }
}

function* getMyPromotersPortion({ payload: params }) {
  try {
    const { UsersService } = yield getContext(CONTEXT.SERVICES);

    const { data, pagination } = yield call(getMyPromotersAsync, {
      UsersService,
      params,
    });

    yield put(getMyPromotersPortionSuccess({ data, ...pagination }));
  } catch ({ error }) {
    yield put(getMyPromotersPortionFailure(error));
  }
}

const getPromotersByIdAsync = ({ UsersService, id, params }) => {
  if (!UsersService) {
    console.log("Required services does not exist");
    return null;
  }

  return UsersService.promotersByUserId(id, params);
};

function* getPromotersById({ payload }) {
  try {
    const { UsersService } = yield getContext(CONTEXT.SERVICES);
    const { id, ...params } = payload;

    const { data, pagination } = yield call(getPromotersByIdAsync, {
      UsersService,
      id,
      params,
    });

    yield put(getPromotersByIdSuccess({ data, ...pagination }));
  } catch ({ error }) {
    yield put(getPromotersByIdFailure(error));
  }
}

function* getPromotersByIdPortion({ payload }) {
  try {
    const { UsersService } = yield getContext(CONTEXT.SERVICES);
    const { id, ...params } = payload;

    const { data, pagination } = yield call(getPromotersByIdAsync, {
      UsersService,
      id,
      params,
    });

    yield put(getPromotersByIdPortionSuccess({ data, ...pagination }));
  } catch ({ error }) {
    yield put(getPromotersByIdPortionFailure(error));
  }
}

export function* watchGetMyPromoters() {
  yield takeEvery(getMyPromotersActionTypes.request, getMyPromoters);
}

export function* watchGetMyPromotersPortion() {
  yield takeEvery(
    getMyPromotersPortionActionTypes.request,
    getMyPromotersPortion,
  );
}

export function* watchPromotersById() {
  yield takeEvery(getPromotersByIdActionTypes.request, getPromotersById);
}

export function* watchPromotersByIdPortion() {
  yield takeEvery(
    getPromotersByIdPortionActionTypes.request,
    getPromotersByIdPortion,
  );
}
